import { createFileRoute } from "@tanstack/react-router";
import { i18nLinks, i18nOgMeta, localeUrl } from "@/lib/seo";
import { m } from "@/paraglide/messages";
import { NumberBasePage } from "@/tools/number-base/pages/NumberBasePage";

const PATH = "/number-base";

export const Route = createFileRoute("/number-base")({
  ssr: true,
  head: () => ({
    meta: [
      { title: m.nb_meta_title() },
      { name: "description", content: m.nb_meta_description() },
      { property: "og:title", content: m.nb_meta_title() },
      { property: "og:description", content: m.nb_meta_description() },
      ...i18nOgMeta(PATH),
    ],
    links: [...i18nLinks(PATH)],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: m.nb_breadcrumb_home(),
              item: localeUrl(`/`),
            },
            {
              "@type": "ListItem",
              position: 2,
              name: m.nb_tool_name(),
              item: localeUrl(`${PATH}`),
            },
          ],
        }),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: [
            {
              "@type": "Question",
              name: m.nb_faq1_q(),
              acceptedAnswer: { "@type": "Answer", text: m.nb_faq1_a() },
            },
            {
              "@type": "Question",
              name: m.nb_faq2_q(),
              acceptedAnswer: { "@type": "Answer", text: m.nb_faq2_a() },
            },
            {
              "@type": "Question",
              name: m.nb_faq3_q(),
              acceptedAnswer: { "@type": "Answer", text: m.nb_faq3_a() },
            },
            {
              "@type": "Question",
              name: m.nb_faq4_q(),
              acceptedAnswer: { "@type": "Answer", text: m.nb_faq4_a() },
            },
          ],
        }),
      },
    ],
  }),
  component: NumberBasePage,
});
